module.exports = __webpack_public_path__ + "static/img/13.5db6943.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/13.png
// module id = Ns96
// module chunks = 0